import { deepFreeze } from "@/utils/structure";

export const HOME_OG_IMAGE_URL =
  "https://cdn.sanity.io/images/bm4duuk0/production/d79a1f8ce04ae86ccc1ecdae494598c96538683b-1200x630.png";

// taking from https://stripe.com/docs/api/payment_methods/object#payment_method_object-type
export const PAYMENT_METHODS = deepFreeze({
  PAYNOW: "Stripe PayNow",
  CARD: "Stripe Card",
});
export const STRIPE_CHECKOUT_SESSION_VERSIONS = {
  V2: "v2",
};
export const CARD_SURCHARGE_PERCENTAGE = 3;
export const MAX_SHIPMENTS_PER_CHECKOUT = 80;
export const MAX_SHIPMENTS_PER_TOPUP = 50;
export const MIN_ITEM_DESCRIPTION_LENGTH = 20;
export const MAX_ITEM_DESCRIPTION_LENGTH = 100;
export const STANDARD_SHIPPING_CONSUMER_SURCHARGE_SGD = 12.5;
export const RURAL_SURCHARGE_SGD = 33.6;
export const DIRECT_SIGNATURE_CHARGE_SGD = 7;
export const INSURANCE_CHARGE_PERCENTAGE = 2.4;
export const PICKUP_MOQ_SURCHARGE = 8;
export const MIN_CHEAPER_SHIPMENT_QTY = 3;

export const PICKUP_LOCATION_SURCHARGES_AND_INFO = [
  {
    name: "Changi Airport",
    postalCodePrefixes: ["819", "918146"],
    value: 20,
    additionalInfoLink:
      "https://support.justship.sg/en/article/special-locations-additional-pick-up-surcharge-what-to-note-1vpcq5f/",
    additionalInfoPrompt:
      "missing documents may cause a failed, non-refundable pick-up",
  },
  {
    name: "Sentosa",
    postalCodePrefixes: ["098", "099"],
    postalCodeExclusions: [
      // this is generated by o3
      // add to this if any prominent areas have been missed

      // VivoCity / HarbourFront Centre
      "098585", // VivoCity (main mall)
      "099253",
      "099254",
      "099255",
      "099256",
      "099257",
      "099258",

      // Keppel Bay Tower & HarbourFront Avenue
      // and Caribbean at Keppel Bay
      "098630",
      "098631",
      "098632",
      "098633",
      "098635",
      "098636",
      "098637",
      "098638",
      "098639",
      "098640",
      "098641",
      "098642",
      "098643",
      "098644",
      "098645",
      "098646",
      "098647",
      "098648",
      "098649",
      "098650",
      "098651",
      "098652",
      "098653",
      "098654",
      "098655",
      "098656",
      "098657",

      // Corals at Keppel Bay 098012 - 098023
      "098012",
      "098013",
      "098014",
      "098015",
      "098016",
      "098017",
      "098018",
      "098019",
      "098020",
      "098021",
      "098022",
      "098023",

      // Keppel Bay View cluster
      "098402",
      "098404",
      "098405",
      "098406",
      "098407",
      "098408",
      "098413",
      "098414",
      "098415",
      "098416",
      "098417",
      "098418",
      "098419",

      // Lower Delta / Maritime Sq
      "099309",
      "099310",

      // Keppel Island offices
      "098830",
      "098831",
      "098832",
    ],
    value: 8,
  },
  {
    name: "ICA",
    postalCodePrefixes: ["208718"],
    value: 20,
    additionalInfoLink:
      "https://support.justship.sg/en/article/special-locations-additional-pick-up-surcharge-what-to-note-1vpcq5f/",
    additionalInfoPrompt:
      "missing documents may cause a failed, non-refundable pick-up",
  },
  {
    name: "ComfortDelGro",
    postalCodePrefixes: ["575717"],
    value: 20,
    additionalInfoLink:
      "https://support.justship.sg/en/article/special-locations-additional-pick-up-surcharge-what-to-note-1vpcq5f/",
    additionalInfoPrompt:
      "missing documents may cause a failed, non-refundable pick-up",
  },
  {
    name: "Hotel",
    addressLineKeywords: ["hotel", "resort"],
    value: 0, // no surcharge for hotels
    additionalInfoLink:
      "https://support.justship.sg/en/article/special-locations-additional-pick-up-surcharge-what-to-note-1vpcq5f/",
    additionalInfoPrompt: "proceed only after reading",
  },
];

export const STANDARD_SHIPPING_ENABLED =
  process.env.NEXT_PUBLIC_STANDARD_SHIPPING_ENABLED === "1" || false;
export const ECOMMERCE_STANDARD_SHIPPING_ENABLED =
  process.env.NEXT_PUBLIC_ECOMMERCE_STANDARD_SHIPPING_ENABLED === "1" || false;
export const ECOMMERCE_EXPRESS_LITE_TRIAL_ENABLED =
  process.env.NEXT_PUBLIC_ECOMMERCE_EXPRESS_LITE_TRIAL_ENABLED === "1" || false;
export const SHIPPING_METHODS = deepFreeze({
  POSTAL: {
    label: "Postal Shipping",
    value: "POSTAL",
    duration: "10-14 working days",
  },
  STANDARD: {
    label: "Standard Shipping",
    value: "STANDARD",
    duration: "6-9 working days",
  },
  SELECT: {
    label: "Select Shipping",
    value: "SELECT",
    duration: "6-10 working days",
  },
  EXPRESS: {
    label: "Express Shipping",
    value: "EXPRESS",
    duration: "2-5 working days",
  },
});

export const BULK_UPLOAD_ECOMMERCE_ENABLED =
  process.env.NEXT_PUBLIC_BULK_UPLOAD_ECOMMERCE_ENABLED === "1" || false;

export const USER_READ_DATA_FROM_POSTGRESQL =
  process.env.USER_READ_DATA_FROM_POSTGRESQL === "1" || false;
export const SHIPMENT_READ_DATA_FROM_POSTGRESQL =
  process.env.SHIPMENT_READ_DATA_FROM_POSTGRESQL === "1" || false;
export const CART_READ_DATA_FROM_POSTGRESQL =
  process.env.CART_READ_DATA_FROM_POSTGRESQL === "1" || false;
export const PRICING_READ_DATA_FROM_POSTGRESQL =
  process.env.PRICING_READ_DATA_FROM_POSTGRESQL === "1" || false;
export const PAYMENT_READ_DATA_FROM_POSTGRESQL =
  process.env.PAYMENT_READ_DATA_FROM_POSTGRESQL === "1" || false;
export const WHATSAPP_BUSINESS_READ_DATA_FROM_POSTGRESQL =
  process.env.WHATSAPP_BUSINESS_READ_DATA_FROM_POSTGRESQL === "1" || false;
export const TRACKING_READ_DATA_FROM_POSTGRESQL =
  process.env.TRACKING_READ_DATA_FROM_POSTGRESQL === "1" || false;
export const GIFT_CARD_READ_DATA_FROM_POSTGRESQL =
  process.env.GIFT_CARD_READ_DATA_FROM_POSTGRESQL === "1" || false;
export const NEXT_PUBLIC_STANDARD_SHIPMENT_DOWNLOAD_LABEL =
  process.env.NEXT_PUBLIC_STANDARD_SHIPMENT_DOWNLOAD_LABEL === "1" || false;
export const POSTAL_SHIPPING_ENABLED =
  process.env.NEXT_PUBLIC_POSTAL_SHIPPING_ENABLED === "1" || false;
export const SELECT_SHIPPING_ENABLED =
  process.env.NEXT_PUBLIC_SELECT_SHIPPING_ENABLED === "1" || false;

export const TIER_3_TABLES_READ_DATA_FROM_POSTGRESQL =
  process.env.TIER_3_TABLES_READ_DATA_FROM_POSTGRESQL === "1" || false;
export const TIER_2_TABLES_READ_DATA_FROM_POSTGRESQL =
  process.env.TIER_2_TABLES_READ_DATA_FROM_POSTGRESQL === "1" || false;
export const TIER_1_TABLES_READ_DATA_FROM_POSTGRESQL =
  process.env.TIER_1_TABLES_READ_DATA_FROM_POSTGRESQL === "1" || false;

export const DEFAULT_COUNTRY_CALL_CODE = "SG/+65";

export const OPTIMIZE_COOKIE_NAME = "ab-optimize";

export const VALENTINES_BOUQUET_PRICE = 42;

export const EXCLUDED_COUNTRIES = [
  "SG", // Singapore

  "AF", // Afghanistan
  "AD", // Andorra
  "BY", // Belarus
  "CF", // Central African Republic
  "CU", // Cuba
  "FK", // Falkland Islands
  "GQ", // Equatorial Guinea
  "GW", // Guinea-Bissau
  "IR", // Iran
  "JT", // Johnston Island
  "KM", // Comoros
  "SY", // Syria
  "KI", // Kiribati
  "YE", // Yemen Arab Republic
  "KP", // North Korea
  "YT", // Mayotte Island
  "MM", // Myanmar
  "NR", // Nauru
  "NU", // Niue
  "RU", // Russia
  "SH", // St. Helena
  "PM", // St.Pierre and Miquelon
  "ST", // Sao Tome and Prinicpe
  "SB", // Solomon Islands
  "SO", // Somalia
  "SD", // Sudan
  "TJ", // Tajikistan
  "TK", // Tokelu Islands
  "TV", // Tuvalu
  "UA", // Ukraine
  "VE", // Venezuela - FedEx unable to have a fixed set of cities for Venezuela
  "WF", // Wake Islands
];

export const ITEM_CATEGORIES = [
  { value: "mobiles", text: "Mobile Phones" },
  { value: "tablets", text: "Mobile Tablets" },
  { value: "computers", text: "Computers" },
  { value: "cameras", text: "Cameras" },
  { value: "accessories", text: "Cables" },
  // { value: "accessoriesbattery", text: "Accessories (Battery)" },
  { value: "headphones", text: "Headphones & Earphones" },
  { value: "healthbeauty", text: "Beauty & Skincare" },
  { value: "fashion", text: "Clothes" },
  { value: "watches", text: "Watches" },
  { value: "jewelry", text: "Jewelry" },
  { value: "petsaccessories", text: "Pets Accessories" },
  // { value: "dryfoodsupplements", text: "Dry Food & Supplements" }
  { value: "dryfood", text: "Dry Foods" },
  { value: "supplements", text: "Supplements" },
  { value: "homeappliances", text: "Home Appliances" },
  { value: "homedecor", text: "Paintings" },
  { value: "toys", text: "Toys" },
  { value: "sports", text: "Exercise Equipment" },
  { value: "handbags", text: "Handbags" },
  { value: "audiovideo", text: "Audio Video" },
  { value: "documents", text: "Documents & Photos" },
  { value: "gaming", text: "Games & Consoles" },
  // { value: "bookscollectibles", text: "Books" }
  { value: "books", text: "Books" },
];

export const HS_CODE_MAP = {
  mobiles: "851712",
  tablets: "847130",
  computers: "847130",
  cameras: "900659",
  accessories: "854420",
  headphones: "851830",
  healthbeauty: "330410",
  fashion: "630900",
  watches: "910211",
  jewelry: "711790",
  petsaccessories: "420100",
  dryfood: "190590",
  supplements: "293621",
  homeappliances: "851629",
  homedecor: "590190",
  toys: "950300",
  sports: "950631", // refers to golf clubs
  handbags: "420221",
  audiovideo: "852349",
  documents: "491199",
  gaming: "950450",
  books: "490199",
};

export const GIFT_CARD_CONSTANTS = {
  MIN_AMOUNT: 20,
  MAX_NAME_LENGTH: 50,
  MAX_MESSAGE_LENGTH: 200,
  PRESET_AMOUNTS: [50, 100, 300],
  MONTHS_TO_EXPIRY: 12,
};

export const GIFT_CARD_EMAIL_COPY = {
  TERMS_AND_CONDITIONS: [
    "Redeemable for 1 shipment on justship.sg",
    `One time-use only, good for ${GIFT_CARD_CONSTANTS.MONTHS_TO_EXPIRY} months from date of issue`,
    "No returns, refunds on gift card",
  ],
  HOW_TO_REDEEM: [
    {
      text: "Sign up for an account with JustShip at",
      urlType: "REGISTER_URL",
    },
    {
      text: "Click on the gift card above or use this link:",
      urlType: "REDEEM_URL",
    },
    {
      text: "Fill up the shipment form as prompted and enjoy fuss-free international shipping!",
    },
  ],
};

export const getGiftCardUrls = (discountCode) => ({
  REGISTER_URL: `${process.env.NEXT_PUBLIC_HOST}/register`,
  REDEEM_URL: `${process.env.NEXT_PUBLIC_HOST}/create-shipment?discount=${discountCode}`,
});

export const STANDARD_BOXES = [
  {
    name: "A4 Envelope",
    internalName: "A4 Envelope",
    length: 24,
    width: 34,
    height: 1,
  },
  {
    name: "Fedex Box S",
    internalName: "Fedex Box S",
    length: 28,
    width: 5,
    height: 33,
    forInternalOnly: true,
  },
  {
    name: "Fedex Box M",
    internalName: "Fedex Box M",
    length: 30,
    width: 6,
    height: 34,
    forInternalOnly: true,
  },
  {
    name: "Fedex Box L",
    internalName: "Fedex Box L",
    length: 36,
    width: 9,
    height: 49,
    forInternalOnly: true,
  },
  {
    name: "Standard 0.5kg",
    internalName: "N10",
    length: 18,
    width: 10,
    height: 13,
  },
  {
    name: "Standard 1.5kg",
    internalName: "N7",
    length: 24,
    width: 14,
    height: 17,
  },
  {
    name: "Standard 2kg",
    internalName: "N6",
    length: 27,
    width: 16,
    height: 19,
  },
  {
    name: "Standard 2.5kg",
    internalName: "N5",
    length: 30,
    width: 18,
    height: 20,
  },
  {
    name: "Standard 5 kg",
    internalName: "Box B",
    length: 33,
    width: 24,
    height: 31,
  },
  {
    name: "Standard 7 kg",
    internalName: "Box C",
    length: 42,
    width: 26,
    height: 32,
  },
  {
    name: "Standard 12 kg",
    internalName: "Box A",
    length: 49,
    width: 34,
    height: 36,
  },
  {
    name: "Standard 17 kg",
    internalName: "Box E",
    length: 56,
    width: 43,
    height: 35,
  },
  {
    name: "Standard 22.5 kg",
    internalName: "Box D",
    length: 43,
    width: 40,
    height: 65,
  },
];
